





































import {Vue, Component, Prop} from 'vue-property-decorator';
import {PModule} from '@/views/system/modules/interfaces';
import enumsModule from '@/store/modules/enumsModule';
import {PModuleType} from '@/enums/configs';
import hardwareModule from '@/store/modules/entities/hardwareModule';
import DeleteDialog from '@c/DeleteDialog.vue';
import {httpClient} from '@/api/baseApi';
import {pmoduleDataRoutesByTypeMap} from '@v/system/modules/configurate';

@Component({components: {DeleteDialog}})
export default class PortInput extends Vue {
  color = 'grey';

  @Prop({required: true})
  modules!: PModule[];

  @Prop({required: true})
  moduleList: any;

  @Prop({type: Boolean, default: false})
  editFlag!: boolean;

  @Prop({type: Boolean, default: false})
  showTooltip!: boolean;

  modulesList: any[] = [];

  modulesType: any[] = [];

  get listMenu(): {id: number; name: string; type: PModuleType}[] {
    if (this.modules.length && this.moduleList && this.moduleList.length) {
      return this.modules.reduce((acc: any[], item: PModule) => {
        const module = this.moduleList.find((m: any) => m.guid === item.guid);
        //TODO: почему может быть ситуация с ненайденым модулем?
        if (module) {
          acc.push({id: item.id, name: module.name, type: module.type});
        } else acc.push({id: item.id, name: 'REMOVED MODULE', type: null});
        return acc;
      }, []);
    } else {
      return [];
    }
  }

  async created() {
    if (!this.modules) return;
  }

  getType(item: any) {
    return enumsModule.moduleTypes.filter(x => x.value == item.type)[0].description;
  }

  onClickMenuItem(alias: string) {
    console.error('NOT IMPLEMENTED!!!!' + alias);
  }

  async onClickInput(module: any) {
    await httpClient.get(`modules/`).then((res: any) => {
      this.modulesList = res.data;
    });
    const mod = this.modulesList.filter(x => x.name == module.name);

    const {href} = this.$router.resolve({
      name: pmoduleDataRoutesByTypeMap.get(module.type),
      params: {id: `${mod[0].id}`},
    });
    window.open(href, '_blank');
  }

  async removeModule(id: any) {
    await hardwareModule.deletePmmodule(id);
    this.$emit('removeModule');
  }

  async onBtn2Click(data: any) {
    try {
      const currentModule = enumsModule.moduleTypes.filter(v => v.value === data.itemType);
      await httpClient.get(`modules/`).then((res: any) => {
        this.modulesList = res.data;
      });
      const mod = this.modulesList.filter(x => x.name == data.itemName); //ищем в журнале ПМ с таким же названием
      await httpClient.delete(`/${currentModule[0].url}/${mod[0].id}`);
      this.$emit('removeModule');
      this.deleteDialog.close();
    } catch (e) {
      this.deleteDialog.error('Произошла ошибка');
    }
  }

  get deleteDialog() {
    return this.$refs.deleteDialog as any;
  }

  deleteItem(itemID: number, itemType: any, itemName: string) {
    const isFromPort = true;
    const btn1 = 'Удалить связь';
    const btn2 = 'Удалить ПМ';
    this.deleteDialog.open(
      {itemID, itemType, itemName, isFromPort, btn1, btn2},
      {
        deleteCallback: async () => {
          try {
            this.removeModule(itemID);
            this.deleteDialog.close();
          } catch (e) {
            this.deleteDialog.error('Произошла ошибка');
          }
        },
      },
    );
  }
}
